var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSparkles = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 27,
  height: 27,
  viewBox: "0 0 27 27",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M10.3163 16.6837L4 15L10.3163 13.3163L12 7L13.6837 13.3163L20 15L13.6837 16.6837L12 23L10.3163 16.6837Z",
  fill: "currentColor"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M22.7634 4.23664L20 3.5L22.7634 2.76336L23.5 0L24.2366 2.76336L27 3.5L24.2366 4.23664L23.5 7L22.7634 4.23664Z",
  fill: "currentColor"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M18.9738 25.0262L17 24.5L18.9738 23.9738L19.5 22L20.0262 23.9738L22 24.5L20.0262 25.0262L19.5 27L18.9738 25.0262Z",
  fill: "currentColor"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M1.97383 8.02617L0 7.5L1.97383 6.97383L2.5 5L3.02617 6.97383L5 7.5L3.02617 8.02617L2.5 10L1.97383 8.02617Z",
  fill: "currentColor"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgSparkles);
export default ForwardRef;